import React, { useEffect, Fragment } from "react";
import Footer from "./Template/Footer.js";
import NavBar from "./Template/NavBar.js";
import SubMenu from "./Template/SubMenu.js";
import MapView from "./MapView";
import regantes from "./Images/regantesolponienteportada.jpeg";
import { Col, Card, Row, Container } from "react-bootstrap";
function Home() {
  useEffect(() => {}, []);
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <NavBar></NavBar>
      {/* <SubMenu></SubMenu> */}
      <MapView></MapView>
      {/* <Footer></Footer> */}
    </div>
  );
}

export default Home;
